import Cookies from 'js-cookie';
import { getWixClient } from './wix-client.base';

export const getBrowserWixClient = () => getWixClient({ cookieStore: Cookies });
